import { render, staticRenderFns } from "./datils.vue?vue&type=template&id=5c334186&scoped=true&"
import script from "./datils.vue?vue&type=script&lang=js&"
export * from "./datils.vue?vue&type=script&lang=js&"
import style0 from "./datils.vue?vue&type=style&index=0&id=5c334186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c334186",
  null
  
)

export default component.exports